import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7fb99b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderUploadTutorial_Content" }
const _hoisted_2 = { class: "OrderUploadTutorial_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OrderUploadTutorial_Header_Title" }, "ファイルのフォーマット・注意点について", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OrderUploadTutorial_Main" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 下記フォーマットに沿った"),
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Excelファイル"),
    /*#__PURE__*/_createTextVNode("をアップロードすると、受注処理が実行されます。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "OrderUploadTutorial_TableContainer" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "OrderUploadTutorial_Table" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("th", null, "コード区分"),
          /*#__PURE__*/_createElementVNode("th", null, "商品コード"),
          /*#__PURE__*/_createElementVNode("th", null, "数量")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "1"),
          /*#__PURE__*/_createElementVNode("td", null, "ISBN(13桁)を記載"),
          /*#__PURE__*/_createElementVNode("td", null, "1")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "2"),
          /*#__PURE__*/_createElementVNode("td", null, "ISBN(10桁)を記載"),
          /*#__PURE__*/_createElementVNode("td", null, "1")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "3"),
          /*#__PURE__*/_createElementVNode("td", null, "出版社書誌コードを記載"),
          /*#__PURE__*/_createElementVNode("td", null, "1")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "4"),
          /*#__PURE__*/_createElementVNode("td", null, "書誌コードを記載"),
          /*#__PURE__*/_createElementVNode("td", null, "1")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "【注意】"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" ・"),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "コード区分/商品コード/数量のヘッダ情報"),
      /*#__PURE__*/_createTextVNode("は"),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "必ず"),
      /*#__PURE__*/_createTextVNode("記載してください。 ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " ・商品コード欄には「ISBN(13桁)」「ISBN(10桁)」「出版社書誌コード」「書誌コード」のいずれかを入力してください。 "),
    /*#__PURE__*/_createElementVNode("p", null, "・コード区分欄は使用する商品コードに沿って下記の通りに入力してください。"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" ※ISBN(13桁)の場合: "),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "1"),
      /*#__PURE__*/_createTextVNode(", ISBN(10桁)の場合:"),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "2"),
      /*#__PURE__*/_createTextVNode(", 出版社書誌コードの場合:"),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "3"),
      /*#__PURE__*/_createTextVNode(", 書誌コードの場合:"),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "4")
    ])
  ])
], -1))

import { ref, reactive, computed, watch } from "vue";
import BtnGreenSmall from "../atoms/button/BtnGreenSmall.vue";
import BtnGreen from "../atoms/button/BtnGreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOrderUploadTutorial',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const closeModal = () => {
  emit("close");
};
// const imgPath = require("../assets/img/tutorial.jpg");


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "OrderUploadTutorial",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "OrderUploadTutorial_Header_Close",
          icon: "xmark"
        })
      ]),
      _hoisted_4
    ])
  ]))
}
}

})